/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "account": {
            "nested": {
              "common": {
                "nested": {
                  "CaptchaType": {
                    "values": {
                      "CAPTCHA_TYPE_UNKNOWN": 0,
                      "RECAPTCHA_V2_CHECKBOX": 1,
                      "RECAPTCHA_V2_ANDROID": 2,
                      "RECAPTCHA_ENTERPRISE_ANDROID": 3,
                      "RECAPTCHA_ENTERPRISE_IOS": 4,
                      "RECAPTCHA_ENTERPRISE_WEB": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.account?.nested?.common?.nested?.CaptchaType) {
  $root.addJSON(jsonData);
}

/**
 * Used to determine which CAPTCHA type the client is using.
 * The server will then map this to the appropriate API key to render a CAPTCHA challenge.
 * The serialized string value of each enum must have a mapping in the "onboarding/captcha_api_key"
 * feature flag (except CAPTCHA_TYPE_UNKNOWN).
 * This may not be used if CAPTCHA validation is not turned on.
 * See sqareup.onboarding.account.common.RecaptchaFailure#api_key.
 *
 * SOURCE CaptchaType @ squareup/onboarding/account/common.proto at 16:1
 */
export const CaptchaType = $root.lookupEnum('squareup.onboarding.account.common.CaptchaType').values;